module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Will You Be My Escort")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Meg Harding")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("A Carlisles Novel")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jackson Carlisle has rotten luck with men and women, and after an especially bad situation, he takes a step back from romance. But with a two-week family reunion in Hawaii looming, his mom is determined to set him up with one of the sweet singles she knows would be perfect for him. A normal person would tell her no and be done with it. Instead, Jackson tells her he has a boyfriend. The only problem? He doesn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Aaron Wilkes is an escort. He’s a little surprised when a friend’s girlfriend hires him to date her brother, but he’s had stranger jobs. Jackson is cute, and he thinks a fling with Aaron might be just the kind of no-strings-attached fun he needs to get over his dry spell. As they explore the islands together, their carefully laid plans begin to get away from them. Feelings aren’t supposed to come into play, but that shouldn’t be a problem. After all, you can’t fall in love in two weeks….")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0